import React from "react";
import Reveal from "./Reveal";

const MEHAK =
  "https://customer-assets.emergentagent.com/job_stand-out-branding/artifacts/hpndfjxn_0424.JPG";
const JORDAN =
  "https://customer-assets.emergentagent.com/job_stand-out-branding/artifacts/e6slxyv1_LLDN5597.JPG";

const Founder = ({ img, name, role, body, testId, align = "left" }) => (
  <Reveal
    className={`col-span-12 md:col-span-6 min-w-0 ${align === "right" ? "lg:pl-8" : "lg:pr-8"}`}
    data-testid={`founder-${testId}`}
  >
    <div className="lt-img-wrap aspect-[4/5] mb-8 bg-[var(--lt-cream)] w-full max-w-[360px] mx-auto md:mx-0">
      <img src={img} alt={name} className="w-full h-full object-cover" />
    </div>
    <div className="flex items-baseline justify-between mb-5 max-w-[420px]">
      <h3
        className="font-display tracking-editorial text-[var(--lt-charcoal)]"
        style={{ fontSize: "clamp(1.5rem, 2vw, 1.9rem)", fontWeight: 600 }}
      >
        {name}
      </h3>
      <span className="text-[10px] uppercase tracking-[0.2em] text-[var(--lt-bark)]">
        {role}
      </span>
    </div>
    <p className="text-[var(--lt-bark)] leading-relaxed text-base max-w-[420px]">{body}</p>
  </Reveal>
);

const Founders = () => {
  return (
    <section
      id="about"
      data-testid="founders-section"
      className="py-28 lg:py-36 bg-[var(--lt-peace)]"
    >
      <div className="container mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 mb-20 lg:mb-24">
          <div className="col-span-12 lg:col-span-6">
            <Reveal>
              <p className="eyebrow mb-4">/ Founders</p>
              <h2
                className="font-display tracking-editorial text-[var(--lt-charcoal)] leading-[1.05]"
                style={{ fontSize: "clamp(2rem, 4.4vw, 3.8rem)", fontWeight: 600 }}
              >
                Built by operators who've{" "}
                <em className="italic text-[var(--lt-bark)]">lived</em> the work.
              </h2>
            </Reveal>
          </div>
          <div className="col-span-12 lg:col-span-5 lg:col-start-8 flex items-end">
            <Reveal delay={160}>
              <p className="text-[var(--lt-bark)] text-base lg:text-lg max-w-md">
                Strategy meets craft. Two founders who pair thought leadership with the
                executional rigour of a senior creative team.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-10 lg:gap-16">
          <Founder
            testId="mehak"
            img={MEHAK}
            name="Mehak Hussain"
            role="Founder & Head of Strategy"
            body="Mehak founded Little Things on a simple belief that business is personal. With a background across leadership, culture and strategy, she helps founders translate vision and behaviour into clear, compounding positioning."
          />
          <Founder
            testId="jordan"
            img={JORDAN}
            name="Jordan Young"
            role="Head of Content"
            align="right"
            body="Five years in production across lighting, cinematography and editing, paired with a deep instinct for platform algorithms. Jordan leads content with precision and series-driven thinking that scales."
          />
        </div>
      </div>
    </section>
  );
};

export default Founders;
